var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMulta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 9.33331H11.6666C11.0478 9.33331 10.4543 9.57915 10.0167 10.0167C9.57913 10.4543 9.33329 11.0478 9.33329 11.6666C9.33329 12.2855 9.57913 12.879 10.0167 13.3166C10.4543 13.7541 11.0478 14 11.6666 14H16.3333C16.9521 14 17.5456 14.2458 17.9832 14.6834C18.4208 15.121 18.6666 15.7145 18.6666 16.3333C18.6666 16.9522 18.4208 17.5456 17.9832 17.9832C17.5456 18.4208 16.9521 18.6666 16.3333 18.6666H9.33329M14 20.4166V7.58331M4.66663 2.33331V25.6666L6.99996 24.5L9.33329 25.6666L11.6666 24.5L14 25.6666L16.3333 24.5L18.6666 25.6666L21 24.5L23.3333 25.6666V2.33331L21 3.49998L18.6666 2.33331L16.3333 3.49998L14 2.33331L11.6666 3.49998L9.33329 2.33331L6.99996 3.49998L4.66663 2.33331Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulta);
export default __webpack_public_path__ + "static/media/multa.54ae89781baa770d98dbbbf2ead7f90e.svg";
export { ForwardRef as ReactComponent };